module.exports = __webpack_public_path__ + "img/MEPHeader2.dae9726d.png";